export const PROCTORING_INACTIVITY_MS = 3 * 60_000;
export const PROCTORING_INACTIVITY_MINUTES = PROCTORING_INACTIVITY_MS / 60_000;

export function createInactivityWatchdog(
  thresholdMs = PROCTORING_INACTIVITY_MS,
  startedAt = Date.now(),
) {
  let lastActivityAt = startedAt;
  let reported = false;

  return {
    markActivity(at = Date.now()) {
      lastActivityAt = at;
      reported = false;
    },
    shouldReport(at = Date.now(), visible = true) {
      if (!visible || reported || at - lastActivityAt < thresholdMs) return false;
      reported = true;
      return true;
    },
  };
}
